module.exports = __webpack_public_path__ + "static/media/pause.654f6609.svg";